export const fetchProcessStatus = async (IDD) => {
    try {
        const response = await fetch("https://deep-sage.softmining.it/stats.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                serviceName: "HTOP",
                IDD: IDD,
                Token: "000111"
            }),
        });
        const data = await response.json();
        console.log(data);
        return data;
    } catch (error) {
        console.error("Error HTOP:", error);
        throw error;
    }
};

export const KillProcessStatus = async (IDD, PID) => {
    try {
        const response = await fetch("https://deep-sage.softmining.it/fs.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                serviceName: "SIGTERM",
                IDD: IDD,
                PID: PID,
                Token: "000111"
            }),
        });
        const data = await response.json();
        console.log("kill");
        console.log(data);
        return data;
    } catch (error) {
        console.error("Error KILLJOB:", error);
        throw error;
    }
};


